/* SAMAR — easy ordering helpers.
   1) Page opened with ?order=1 (product page from a card's «اطلبي الآن», or the
      cart from a routine's «اشتري الروتين الآن») → open the WhatsApp order form.
   2) "Add all" buttons ([data-add-items="id,id,id"]) for routine kits and the quiz;
      with data-checkout the button opens the cart's WhatsApp order form after adding.
   3) Help-me-choose quiz ([data-quiz]): 2 questions → routine from product tags.
   4) Quick-browse buttons ([data-qb-open="tag"]): load assets/quick-browse.js/.css on first tap. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- 1. open order form from ?order=1 ---------- */
  try {
    var params = new URLSearchParams(location.search);
    if (params.get('order') === '1') {
      var tries = 0;
      var openForm = function () {
        var btn = document.querySelector('[data-order-open]');
        if (btn && document.querySelector('[data-order-popup]')) {
          btn.click();
          params.delete('order');
          var q = params.toString();
          history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
        } else if (++tries < 40) {
          setTimeout(openForm, 100);
        }
      };
      if (document.readyState === 'complete') openForm(); else window.addEventListener('load', openForm);
    }
  } catch (e) {}

  /* ---------- money ---------- */
  function money(cents, format) {
    var n = (cents / 100);
    var s = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, '');
    return (format || '{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
  }

  /* ---------- 2. add several products to the cart ---------- */
  function updateBadge(cart) {
    document.dispatchEvent(new CustomEvent('samar:cart:updated', { detail: cart }));
    var link = document.getElementById('HeaderCartLink');
    if (!link) return;
    var badge = link.querySelector('.cart-count');
    if (!badge && cart.item_count > 0) { badge = document.createElement('span'); badge.className = 'cart-count'; link.appendChild(badge); }
    if (badge) badge.textContent = Math.min(cart.item_count, 99);
  }
  function addAll(btn) {
    if (btn.classList.contains('is-loading')) return;
    /* "id" or "id:quantity" (the quiz sends the quantities she picked) */
    var items = (btn.getAttribute('data-add-items') || '').split(',').filter(Boolean).map(function (x) { var a = x.split(':'); return { id: +a[0], quantity: Math.max(+a[1] || 1, 1) }; });
    if (!items.length) return;
    btn.classList.add('is-loading');
    /* products already in the cart? ask first (bottom sheet, cart-ui.js) */
    (window.SamarDup ? SamarDup.check(items) : Promise.resolve(items))
      .then(function (list) {
        if (!list || !list.length) throw 'skip';
        return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: list }) });
      })
      .then(function (r) { if (!r.ok) throw 0; return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (btn.hasAttribute('data-checkout')) { location.href = root + 'cart?order=1'; return; }
        var label = btn.querySelector('[data-label]') || btn;
        var old = label.textContent;
        label.textContent = btn.getAttribute('data-added') || old;
        updateBadge(cart);
        setTimeout(function () { label.textContent = old; }, 2200);
      })
      .catch(function () {})
      .then(function () { btn.classList.remove('is-loading'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-add-items]');
    if (btn) { e.preventDefault(); addAll(btn); }
  });

  /* ---------- 4. quick-browse feed: download its code only when first tapped ---------- */
  var qbLoading = null;
  function loadQB() {
    if (window.SamarQB) return Promise.resolve();
    if (qbLoading) return qbLoading;
    var c = window.SAMAR_QB || {};
    if (!c.js) return Promise.reject();
    qbLoading = Promise.all([
      new Promise(function (res) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = c.css; l.onload = res; l.onerror = res; document.head.appendChild(l); }),
      new Promise(function (res, rej) { var sc = document.createElement('script'); sc.src = c.js; sc.onload = res; sc.onerror = rej; document.head.appendChild(sc); })
    ]).catch(function (e) { qbLoading = null; throw e; });
    return qbLoading;
  }
  document.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('[data-qb-open]')) loadQB().catch(function () {}); }, { passive: true });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-qb-open]');
    if (!b) return;
    e.preventDefault();
    var tag = b.getAttribute('data-qb-open') || '';
    /* product lists: open with the filter chips that are selected on the page (comma-separated) */
    if (b.hasAttribute('data-qb-list')) { tag = Array.prototype.map.call(document.querySelectorAll('[data-filter-tag].is-active'), function (c) { return c.getAttribute('data-filter-tag'); }).join(','); }
    b.classList.add('is-loading');
    loadQB().then(function () { window.SamarQB.open(tag); }).catch(function () {}).then(function () { b.classList.remove('is-loading'); });
  });

  /* ---------- 3. quiz ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  document.querySelectorAll('[data-quiz]').forEach(function (quiz) {
    var data; try { data = JSON.parse(quiz.querySelector('[data-quiz-products]').textContent); } catch (e) { return; }
    var T = JSON.parse(quiz.querySelector('[data-quiz-text]').textContent);
    var fmt = quiz.getAttribute('data-money-format');
    var step2 = quiz.querySelector('[data-quiz-step="2"]');
    var out = quiz.querySelector('[data-quiz-result]');
    var cart = quiz.querySelector('[data-cart-icon]');
    var choice = { skin: null, concern: null };

    /* the steps a product covers (a moisturiser with SPF covers two) */
    var COVERS = { 'type:cleanser': ['type:cleanser', 'type:exfoliant'], 'type:treatment': ['type:treatment'], 'type:moisturizer': ['type:moisturizer'], 'type:sunscreen': ['type:sunscreen'] };
    function covers(p, st) { return COVERS[st].some(function (t) { return p.g.indexOf(t) > -1; }); }
    function family(p) { return String(p.t || '').split(' – ')[0].trim(); }
    function pick(stepTag, used, fams) {
      var best = null, bestScore = -1;
      data.forEach(function (p) {
        if (used[p.h] || fams[family(p)]) return;
        var g = '|' + p.g.join('|') + '|';
        if (g.indexOf('|' + stepTag + '|') < 0 || g.indexOf('|area:face|') < 0) return;
        var s = 0;
        if (g.indexOf('|skin:' + choice.skin + '|') > -1) s += 3;
        var c = { acne: 'skin:acne', hydration: 'skin:dry', sun: 'type:sunscreen', sensitive: 'skin:sensitive' }[choice.concern];
        if (c && g.indexOf('|' + c + '|') > -1) s += 3;
        if (g.indexOf('|area:body|') < 0) s += 1; /* face-only products first */
        if (s > bestScore) { bestScore = s; best = p; }
      });
      return best;
    }
    function build() {
      var steps = ['type:cleanser'];
      if (choice.concern === 'acne') steps.push('type:treatment');
      steps.push('type:moisturizer');
      steps.push('type:sunscreen');
      /* sunscreen is chosen before the moisturiser: every SPF here also moisturises,
         so it then covers both steps and no second moisturiser is added */
      var order = steps.filter(function (st) { return st !== 'type:moisturizer'; }).concat(['type:moisturizer']);
      var used = {}, fams = {}, owner = {}, ids = [], total = 0;
      order.forEach(function (st) {
        if (owner[st]) return;
        var p = pick(st, used, fams);
        if (!p) return;
        used[p.h] = 1; fams[family(p)] = 1; ids.push(p.id); total += p.p;
        steps.forEach(function (s2) { if (!owner[s2] && (s2 === st || covers(p, s2))) owner[s2] = p; });
      });
      /* one row per product: big photo with its step number, step name, name, price */
      var rows = [], shown = {};
      steps.forEach(function (st) {
        var p = owner[st];
        if (!p || shown[p.h]) return;
        shown[p.h] = 1;
        var label = steps.filter(function (s2) { return owner[s2] === p; }).map(function (s2) { return T.steps[s2]; }).join(' + ');
        rows.push('<li class="quiz__item"><a class="quiz__ph" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true"><span class="quiz__n">' + (rows.length + 1) + '</span>' +
          '<img src="' + esc(p.i.replace(/width=\d+/, 'width=300')) + '" alt="" width="104" height="104" loading="lazy"></a>' +
          '<div><span class="quiz__item-step">' + esc(label) + '</span><a href="' + esc(p.u) + '">' + esc(p.t) + '</a>' +
          '<div class="quiz__row"><b class="quiz__item-price" dir="auto">' + esc(money(p.p, fmt)) + '</b>' +
          '<span class="quiz__qty" role="group"><button type="button" data-qq="1" aria-label="+">+</button><b data-qn>1</b><button type="button" data-qq="-1" aria-label="−">−</button></span></div></div></li>');
        rows[rows.length - 1] = rows[rows.length - 1].replace('<li class="quiz__item">', '<li class="quiz__item" data-id="' + p.id + '" data-price="' + p.p + '">');
      });
      if (!rows.length) { out.innerHTML = '<p class="quiz__empty">' + esc(T.empty) + '</p>'; out.hidden = false; return; }
      out.innerHTML = '<h3>' + esc(T.result) + '</h3><ul class="quiz__items">' + rows.join('') + '</ul>' +
        '<div class="quiz__foot"><span class="quiz__total" dir="auto" data-quiz-total>' + esc(T.total) + ' ' + esc(money(total, fmt)) + '</span>' +
        '<div class="kit__btns">' +
        '<button type="button" class="button kit__btn kit__btn--buy" data-add-items="' + ids.join(',') + '" data-checkout><span data-label>' + esc(T.buy || T.addAll) + '</span></button>' +
        '<button type="button" class="kit__btn kit__btn--add" data-add-items="' + ids.join(',') + '" data-added="' + esc(T.added) + '">' + (cart ? cart.innerHTML : '') + '<span data-label>' + esc(T.addAll) + '</span></button>' +
        '</div></div>' +
        '<p style="margin:10px 0 0"><button type="button" class="quiz__restart" data-quiz-restart>' + esc(T.restart) + '</button></p>';
      out.hidden = false;
    }
    /* + / − on each suggested product: row price, total and both buttons follow the quantities;
       − on 1 takes the product out of the routine */
    function refresh() {
      var items = out.querySelectorAll('.quiz__item'), list = [], total = 0;
      if (!items.length) { out.innerHTML = '<p class="quiz__empty">' + esc(T.empty) + '</p><p style="margin:10px 0 0"><button type="button" class="quiz__restart" data-quiz-restart>' + esc(T.restart) + '</button></p>'; return; }
      items.forEach(function (li, i) {
        var q = +li.querySelector('[data-qn]').textContent || 1, pr = +li.getAttribute('data-price');
        li.querySelector('.quiz__n').textContent = i + 1;
        li.querySelector('.quiz__item-price').textContent = money(pr * q, fmt);
        list.push(li.getAttribute('data-id') + ':' + q); total += pr * q;
      });
      out.querySelector('[data-quiz-total]').textContent = T.total + ' ' + money(total, fmt);
      out.querySelectorAll('.kit__btns [data-add-items]').forEach(function (b) { b.setAttribute('data-add-items', list.join(',')); });
    }
    quiz.addEventListener('click', function (e) {
      var qb = e.target.closest('[data-qq]');
      if (qb) {
        var li = qb.closest('.quiz__item'), n = li.querySelector('[data-qn]');
        var q = (+n.textContent || 1) + (+qb.getAttribute('data-qq'));
        if (q < 1) li.remove(); else n.textContent = Math.min(q, 10);
        refresh();
        return;
      }
      var chip = e.target.closest('.quiz__chip');
      if (chip) {
        var key = chip.getAttribute('data-key'), val = chip.getAttribute('data-val');
        chip.parentNode.querySelectorAll('.quiz__chip').forEach(function (c) { c.classList.toggle('is-on', c === chip); c.setAttribute('aria-pressed', c === chip); });
        choice[key] = val;
        if (key === 'skin') { step2.hidden = false; }
        if (choice.skin && choice.concern) build();
        return;
      }
      if (e.target.closest('[data-quiz-restart]')) {
        choice = { skin: null, concern: null };
        quiz.querySelectorAll('.quiz__chip').forEach(function (c) { c.classList.remove('is-on'); c.setAttribute('aria-pressed', 'false'); });
        step2.hidden = true; out.hidden = true; out.innerHTML = '';
      }
    });
  });
})();
